<script setup>
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import { faCopyright } from "@fortawesome/free-regular-svg-icons"
  import { faSpinner } from "@fortawesome/free-solid-svg-icons"

  import { RouterView } from 'vue-router'
  import { useLoadingStore } from "@/stores/loadingStore.js"
  import { useDeviceStore } from "@/stores/deviceStore.js";

  import Menu from "@/components/menu.vue"
  import { onMounted } from "vue"

  const loadingStore = useLoadingStore()

  onMounted( () => {
    useDeviceStore().fetchDeviceUUID()
  } )
</script>

<template lang="pug">
  .overlay( :style="{ display: loadingStore.isLoading() ? 'flex' : 'none' }" )
    font-awesome-icon.text-warning( :icon="faSpinner" spin size="2xl" )

  Menu

  .main.mt-1.mb-1
    RouterView( v-slot="{ Component }" )
      transition( name="fade" mode="out-in" )
        component( :is="Component" )

  footer.mt-auto.text-white-50.text-center
    | Copyright
    font-awesome-icon.ms-1.me-1( :icon="faCopyright" )
    | 2023-{{ new Date().getFullYear() }} UCUE LLC, All rights reserved.
</template>

<style scoped lang="scss">
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
